<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center mg-b-20">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding хөтөлбөр</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Дашбоард / Халамжлах дуудлага</li>
              </ol>
            </nav>
            <div class="mg-l-auto d-flex align-items-center">
              <div @click="exportList()" class="rounded bg-success pd-x-10 pd-y-8" role="button">
                <feather type="file" class="tx-white"></feather>
              </div>
              <div class="mx-2">
                <select class="form-control" style="min-width: 160px;" v-model="filter.isDone">
                  <option :value="null" text="Бүгд">Бүгд</option>
                  <option :value="true" text="Тйим">Дуусгасан</option>
                  <option :value="false" text="Үгүй">Дуусгаагүй</option>
                </select>
              </div>
              <div class="tgggler">
                <div @click="init()" class="pd-x-20 pd-y-8" role="button">
                  <feather type="search"></feather>
                  Хайх
                </div>
              </div>
            </div>
          </div>

          <table class="tbl-buddy mg-t-10">
            <thead>
              <tr>
                <th>
                    Овог, нэр
                    <!-- <feather @click="openFilterModal(1)" type="search" class="mg-l-5" role="button"></feather> -->
                </th>
                <th>
                    Домайн
                    <!-- <feather @click="openFilterModal(2)" type="search" class="mg-x-5" role="button"></feather> -->
                </th>
                <th class="w-24 p-1 leading-tight">ХН-с халамжлах дуудлага хийсэн эсэх</th>
                <!-- <th class="lh-1 pd-x-10 tx-12" v-for="b in $store.state.buddy.boxNames">{{ b.boxName }}</th> -->
              </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td colspan="7">
                        <div class="alert alert-secondary mg-t-10" role="alert">
                        Түх хүлээнэ үү.
                        </div>
                    </td>
                </tr>
                <tr v-else-if="list.length<=0">
                    <td colspan="7">
                        <div class="alert alert-secondary mg-t-10" role="alert">
                        Мэдээлэл хоосон байна.
                        </div>
                    </td>
                </tr>
                <tr v-else v-for="(b,bi) in list">
                    <td>
                        <div class="d-flex align-items-center mg-y-6">
                        <div class="mg-r-10" style="min-width: 40px;">
                            <img :src="`${b.newbie.avator}`" class="wd-40 rounded-20" />
                        </div>
                        <div>
                            <div class="d-flex align-items-start">
                                <div class="mg-t-3">{{ getFullName(b.newbie) }}</div>
                                <!-- <div @click.stop="handleUserInfoModal(b.newbie.id)" role="button" class="rounded tx-normal bd bg-light mg-l-5 pd-x-10">
                                    <feather style="width: 18px; height: 18px" type="chevrons-right" class="mg-r-5"></feather>
                                    харах
                                </div> -->
                            </div>
                            <div class="tx-color-03 tx-normal lh-1 tx-12">
                                <template v-if="b.newbie.parentDepart!=undefined">{{b.newbie.parentDepart.name}} - </template>{{b.newbie.depart.name}}{{ b.newbie.position!=null && b.newbie.position!=''?' - ' + b.newbie.position : '' }}
                            </div>
                        </div>
                        </div>
                    </td>
                    <td>{{ b.newbie.loginName }}</td>
                    <td class="text-center">
                      <feather :type="b.isDone?'check-square':'square'"></feather>
                    </td>
                    <!-- <td v-for="bn in $store.state.buddy.boxNames">
                        <div :class="`tx-right ${b.boxesSummary.filter(x=>x.code==bn.code)[0]['progress']>0?'':'tx-normal tx-color-03'}`" v-if="b.boxesSummary.filter(x=>x.code==bn.code).length">
                            {{ b.boxesSummary.filter(x=>x.code==bn.code)[0]['progress'].toFixed(2) }}<sup>%</sup>
                        </div>
                    </td> -->
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-end mg-t-10 pgr-outer">
            <b-pagination
              v-model="pager.currentPage"
              :total-rows="listCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              first-number
              last-number
              align="center"
            ></b-pagination>
          </div>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>


    <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />

  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getConfigValueByKey } from "@/libs/util";
import { request } from "@/api/all";
const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Autocomplete, MessageBox, Message, DatePicker } from "element-ui";

export default {
  components: {
    Autocomplete, MessageBox, DatePicker,Message,
    vueCustomScrollbar,
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    newbies: () => ({
      component: import("@/views/modules/lms/student/buddy/components/newbies.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      list: [],
      listCount: null,
      loading: false,
      pager:{
        perPage:10,
        currentPage: 1
      },
      newbiesCount: null,
      fileDialog: {
        id: null,
        show: false,
      },
      filter:{
        isDone: null
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    openFile(id){
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    exportList(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/newbie/exportCheckList" },
        data: {
          filter: this.filter
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.openFile(res.data.file.id);
        }
      });
    },
    pageChanged(e){
      this.pager.currentPage = e;
      this.init();
    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
          rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },    
    init(){
      this.loading= true;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/newbie/getCheckList" },
        data: { 
          pager:{
              skip: (this.pager.currentPage - 1) * this.pager.perPage,
              size: this.pager.perPage,
          },
          filter: this.filter
        },
        store: this.$store,
      }).then((res) => {
        this.loading= false;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.list= res.data.list;
          this.listCount= res.data.count;
          console.log('call to care', res);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.tgggler{
  div {
    font-weight: 500;
    background: linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);
    border-radius: 5px;
    color: white;
  }
}
</style>